module.exports = __webpack_public_path__ + "img/dybanner.bf9b98c4.png";